function formatTimestamp(iso) {
  try {
    return new Date(iso).toLocaleString("zh-CN", {
      timeZone: "Asia/Shanghai",
      hour12: false,
    });
  } catch {
    return iso || "—";
  }
}

function formatSmartSelector(payload) {
  const contact = payload.contact || {};
  const requirements = payload.requirements || {};
  const regionLabel = payload.region === "domestic" ? "国内询盘" : "海外询盘";

  if (payload.region === "domestic") {
    return {
      _subject: `【官网询盘】专属打印方案 · ${regionLabel}`,
      类型: "专属打印方案",
      区域: regionLabel,
      语言: payload.locale || "—",
      提交时间: formatTimestamp(payload.submittedAt),
      手机: contact.phone || "",
      微信: contact.wechat || "未填写",
      打印产品: requirements.product || "",
      产品尺寸: requirements.size || "",
      预计日产量: requirements.outputLabel || "",
      预算范围: requirements.budgetLabel || "",
      来源页面: payload.pageUrl || "",
    };
  }

  return {
    _subject: `【官网询盘】专属打印方案 · ${regionLabel}`,
    类型: "专属打印方案",
    区域: regionLabel,
    语言: payload.locale || "—",
    提交时间: formatTimestamp(payload.submittedAt),
    国家: contact.country || "",
    WhatsApp: contact.whatsapp || "",
    Email: contact.email || "未填写",
    打印产品: requirements.product || "",
    产品尺寸: requirements.size || "",
    预计日产量: requirements.outputLabel || "",
    预算范围: requirements.budgetLabel || "",
    来源页面: payload.pageUrl || "",
    _replyto: contact.email || undefined,
  };
}

function formatEmailLead(payload) {
  return {
    _subject: "【官网询盘】免费资料包",
    类型: "免费资料包",
    语言: payload.locale || "—",
    提交时间: formatTimestamp(payload.submittedAt),
    邮箱: payload.email || "",
    来源页面: payload.pageUrl || "",
    _replyto: payload.email || undefined,
  };
}

export function formatLeadFormFields(payload) {
  if (payload.source === "email-lead") {
    return formatEmailLead(payload);
  }
  if (payload.source === "smart-selector") {
    return formatSmartSelector(payload);
  }
  throw new Error("Unknown lead source");
}
